<template>
  <CartLayout
    :order="draftOrder"
    :step="1"
    title="カート内"
    sub-title="購入"
    next-text="内容を確認する"
    next-to="/shop/cart/confirmation"
    prev-text="買い物を続ける"
    prev-to="/shop/products"
  >
    <div class="product-list" v-if="draftOrder">
      <CartProductCard
        v-for="orderItem in normalOrder"
        :key="orderItem.id"
        :order-item="orderItem"
        @delete="deleteOrderItem(orderItem)"
      />
    </div>
    <div class="empty" v-if="!draftOrder || !normalOrder.length">通常の購入はありません。</div>
    <CartSectionTitle>リクエスト</CartSectionTitle>
    <div class="product-list" v-if="draftOrder">
      <CartProductCard
        v-for="orderItem in requestOrder"
        :key="orderItem.id"
        :order-item="orderItem"
        @delete="deleteOrderItem(orderItem)"
      />
    </div>
    <div class="empty" v-if="!draftOrder || !requestOrder.length">リクエストはありません。</div>
  </CartLayout>
</template>

<script>
import CartLayout from "@/components/shop/cart/CartLayout.vue";
import CartProductCard from "@/components/shop/cart/CartProductCard.vue";
import CartSectionTitle from "@/components/shop/cart/CartSectionTitle.vue";

export default {
  components: {
    CartLayout,
    CartProductCard,
    CartSectionTitle
  },

  computed: {
    draftOrder() {
      return this.$store.state.orders.draft;
    },
    requestOrder() {
      return this.draftOrder.order_items.filter(o => o.order_item_type === "request");
    },
    normalOrder() {
      return this.draftOrder.order_items.filter(o => o.order_item_type !== "request");
    }
  },

  mounted() {
    this.$store.dispatch("orders/getOrdersDraft");
    this.$store.dispatch("getProfile", "shop");
  },

  methods: {
    async deleteOrderItem(orderItem) {
      await this.$api.delete(`order_items/${orderItem.id}`);
      await this.$store.dispatch("orders/getOrdersDraft");
    }
  }
};
</script>

<style lang="scss" scoped>
.product-list {
  display: grid;
  grid-gap: 8px;
}

.empty {
  margin: 16px 24px;
  color: #777;
  font-size: 14px;
  font-weight: bold;
}
</style>
